<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb />
      </div>
    </div>

    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-12 col-xl-8 mb-2 font-weight-bold">預購單設定檔列表</h4>
        <b-input-group class="col-12 col-xl-4 mb-2">
          <b-form-input
            v-model="query.keyword"
            placeholder="搜尋"
          ></b-form-input>
          <b-input-group-append>
            <b-button @click="handlePageReset">
              <i class="fa fa-search"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="d-flex mb-4 mb-xl-2 justify-content-between">
        <div
          class="
            d-flex
            flex-column flex-xl-row
            align-items-start align-items-xl-center
          "
        >
          <b-button
            v-if="checkPermission([consts.PREORDER_SETTING_CREATE])"
            class="flex-shrink-0 mb-2 mb-xl-0"
            variant="primary"
            :to="{ name: 'PreorderSettingCreate' }"
          >
            <i class="fa fa-plus"></i>新增預購單設定檔
          </b-button>
        </div>
      </div>
      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="preorderSettings"
                :fields="fields"
              >
                <template #cell(is_enabled)="data">
                  <b-badge
                    v-if="data.item.is_enabled == true"
                    variant="success"
                  >
                    啟用
                  </b-badge>
                  <b-badge
                    v-if="data.item.is_enabled == false"
                    variant="secondary"
                  >
                    停用
                  </b-badge>
                </template>
                <template #cell(start_end_time)="data">
                  <div>
                    {{ dateFormatter(data.item.start_at) }}
                  </div>
                  <div>
                    {{ dateFormatter(data.item.end_at) }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    class="mr-1"
                    variant="inverse-dark"
                    @click="showFormUrl(data.item)"
                  >
                    <i class="fa fa-link"></i>
                  </b-button>
                  <b-modal :id="`modal-${data.item.id}`">
                    <template #modal-header="{ close }">
                      <!-- Emulate built in modal header close button action -->
                      <h5 class="m-0 align-self-center">
                        {{ data.item.title }}
                      </h5>
                      <b-button
                        size="sm"
                        variant="link"
                        class="text-dark"
                        @click="close()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                          style="height: 20px"
                        >
                          <path
                            d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                          />
                        </svg>
                      </b-button>
                    </template>
                    <div class="d-flex flex-column align-items-center">
                      <h5 class="mb-2">預購網址</h5>
                      <b-textarea
                        id="form-url"
                        v-b-tooltip.click="'已複製'"
                        v-model="formUrl"
                        @click="copyFormUrl('#form-url')"
                      ></b-textarea>
                      <div>
                        <vue-qr :text="formUrl" ref="qrcode"></vue-qr>
                      </div>
                    </div>
                    <template #modal-footer>
                      <div class="modal-button-group">
                        <b-button
                          variant="primary"
                          class="center-button"
                          @click="downloadQRCode(data.item.title)"
                        >
                          下載QRCode
                        </b-button>
                        <b-button
                          variant="danger"
                          @click="$bvModal.hide(`modal-${data.item.id}`)"
                        >
                          關閉
                        </b-button>
                      </div>
                    </template>
                  </b-modal>
                  <b-button
                    v-if="checkPermission([consts.PREORDER_VIEW])"
                    class="mr-1"
                    variant="inverse-success"
                    :to="{
                      name: 'PreorderList',
                      params: { id: data.item.id },
                    }"
                  >
                    <span class="mdi mdi-list"></span> 預購單列表
                  </b-button>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.PREORDER_SETTING_MODIFY])"
                    variant="inverse-warning"
                    :to="{
                      name: 'PreorderSettingEdit',
                      params: { id: data.item.id },
                    }"
                  >
                    <span class="mdi mdi-lead-pencil"></span> 編輯
                  </b-button>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.PREORDER_SETTING_DELETE])"
                    variant="inverse-danger"
                    @click="deletePreorderSetting(data.item)"
                  >
                    <span class="mdi mdi-delete"></span> 刪除
                  </b-button>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import { format } from "date-fns";
import preorderApi from "@/apis/preorder";
import { mapState } from "vuex";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import generateLiffUrl from "@/mixins/Dashboard/liffUrlHelper";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import VueQr from "vue-qr";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { CustomPagination, VueQr, BreadCrumb },
  mixins: [generateLiffUrl, paginationMixin],
  data() {
    return {
      consts: consts,
      preorderSettings: [],
      showLoading: false,
      fields: [
        { key: "title", label: "預購單名稱", sortable: true },
        { key: "is_enabled", label: "是否啟用", sortable: false },
        { key: "preorders_count", label: "目前預購單筆數", sortable: true },
        { key: "start_end_time", label: "開始結束時間", sortable: false },
        {
          key: "created_at",
          label: "建立時間",
          sortable: true,
          formatter: (value) => {
            return format(new Date(value), "yyyy-MM-dd HH:mm:ss");
          },
        },
        { key: "actions", label: "管理" },
      ],
      totalRows: 0,
      initialized: false,
      query: {
        keyword: "",
        per_page: 20,
        start_at: null,
        end_at: null,
        is_enabled: null,
        page: 1,
      },
      formUrl: null,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchPreorderSettings();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  async mounted() {
    await this.fetchPreorderSettings();
    this.initialized = true;
  },
  methods: {
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    async fetchPreorderSettings() {
      try {
        this.showLoading = true;
        let params = { ...this.query };
        let response = await preorderApi.getPreorderSettings(params);
        this.preorderSettings = response.data.data;
        this.totalRows = response.data.meta.total;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取列表失敗", "error");
      } finally {
        this.showLoading = false;
      }
    },
    async deletePreorderSetting(preorderSetting) {
      try {
        this.showLoading = true;
        const result = await this.$swal({
          type: "warning",
          title: "您確定要刪除嗎？",
          html: `
            <div class="d-block">
              <div class="my-3">
                <div>刪除設定檔：${preorderSetting.title}</div>
              </div>
            </div>`,
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        });

        if (!result.value) {
          return;
        }

        await preorderApi.deletePreorderSetting(preorderSetting.id);
        this.$swal("刪除成功", "", "success");
        await this.fetchPreorderSettings();
      } catch (error) {
        console.error(error);
        this.$swal("刪除失敗", "", "error");
      } finally {
        this.showLoading = false;
      }
    },
    dateFormatter: (value) => {
      if (!value) return "無";
      return format(new Date(value), "yyyy-MM-dd");
    },
    showFormUrl(form) {
      this.formUrl = this.generateLiffUrl(`preorder/${form.id}`);
      this.$bvModal.show(`modal-${form.id}`);
    },
    copyFormUrl(id) {
      const inputText = document.querySelector(id);
      inputText.select();
      document.execCommand("copy");
    },
    downloadQRCode(filename) {
      const base64QRCodeImage = this.$refs?.qrcode?.$el?.src;
      if (base64QRCodeImage) {
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = base64QRCodeImage;
        temporaryDownloadLink.download = filename
          ? `${filename}.png`
          : "qrcode.png";
        temporaryDownloadLink.style.display = "none";
        document.body.appendChild(temporaryDownloadLink);
        temporaryDownloadLink.click();
      }
    },
  },
};
</script>

<style scoped>
.modal-button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.modal-button-group > .center-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
